import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { environment } from "src/environments/environment";
import { AuthService } from "src/services/auth.service";

@Injectable({
    providedIn: 'root'
})

export class ConsumerGuard  {
  mainPath = "" // قراءة القيمة من environment

    constructor(private router: Router,private cookieService: CookieService,private authService:AuthService) {
      this.mainPath= environment.MainPath;

     }
   
    canActivate() {
      const token = this.authService.getToken();

      var role=this.authService.getRole();

      if (token) {
        // Token exists, user is authorized to access the requested route
        return true;
      } else {
        // Token is missing, user is not authorized to access the requested route
        this.router.navigate(['/'+this.mainPath+'/LoginPage']);
        return false;
      }
    }
  }
  